import styled from "styled-components";
import { FlexColumn } from "../../../styles/styled-components-utils";

// Layout
export const CenteredContainer = styled(FlexColumn)`
  justify-content: flex-start;
  align-items: center;
  position: relative;
  flex: 1;
  padding-bottom: env(safe-area-inset-bottom, 20px);
`;

export const CenteredContent = styled.div`
  @media only screen and (max-width: 599px) {
    width: 90%;
  }
  width: 50%;
  position: relative;
`;

// Page chrome (from RestaurantEdit)
export const PageContainer = styled.div`
  flex: 1;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e9f0 100%);
  padding: 24px 16px 48px;
`;

export const PageHeader = styled.div`
  max-width: 800px;
  margin: 0 auto 24px;
  padding: 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeaderLeft = styled.div``;

export const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #212121;
  margin: 0 0 8px;
  display: flex;
  align-items: center;
  gap: 12px;

  i {
    color: #4caf50;
    font-size: 24px;
  }
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: #757575;
  margin: 0;
`;

export const RefreshButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #1565c0;
  background: rgba(21, 101, 192, 0.08);
  border: 1px solid rgba(21, 101, 192, 0.3);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;

  &:hover {
    background: rgba(21, 101, 192, 0.15);
    border-color: rgba(21, 101, 192, 0.5);
  }

  &:focus {
    outline: 2px solid #1565c0;
    outline-offset: 2px;
  }

  i {
    font-size: 16px;
  }
`;

// Tabs
export const TabBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  gap: 2px;

  @media (max-width: 599px) {
    gap: 0;
  }
`;

export const Tab = styled.button`
  padding: 10px 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: ${(props) => (props.$active ? "600" : "400")};
  color: ${(props) =>
    props.$active ? "var(--color-primary, darkgreen)" : "#757575"};
  background: ${(props) => (props.$active ? "white" : "transparent")};
  border: none;
  border-bottom: 2px solid
    ${(props) =>
      props.$active ? "var(--color-primary, darkgreen)" : "transparent"};
  transition: all 0.15s;
  white-space: nowrap;
  &:hover {
    color: var(--color-primary, darkgreen);
  }

  @media (max-width: 599px) {
    padding: 8px 12px;
    font-size: 13px;
  }
`;

export const AddToListButton = styled.button`
  margin-left: auto;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  background: var(--color-primary, darkgreen);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.15s;
  white-space: nowrap;
  &:hover {
    opacity: 0.85;
  }

  @media (max-width: 599px) {
    padding: 6px 12px;
    font-size: 13px;
  }
`;

// Content
export const ContentCard = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  color: #9e9e9e;

  i {
    font-size: 48px;
    margin-bottom: 16px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  p {
    font-size: 16px;
    margin: 0;
  }
`;
